<template lang="pug">
  Modal(ref="dlg" title="HTML preview" closable="true")
    .html-preview-modal.text-center
      div(v-html="html")
    div(slot="footer")
      button.btn.btn-primary(@click="close()") Close
</template>
<script>
import Modal from '@/components/common/Modal'

export default {
  props: {
    html: {
      type: String,
      required: false
    }
  },
  methods: {
    close() {
      this.$refs.dlg.cancel()
    },
    open() {
      this.$refs.dlg.open()
    }
  },
  components: {
    Modal
  }
}
</script>

<style lang="scss">
.html-preview-modal {
  min-width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/HtmlPreviewModal.vue